module.exports = __webpack_public_path__ + "media/honey-icons/icon-boiler-iq-f4b79af1.svg";